export default "__VITE_ASSET__BUcyZA_O__"